<template>
  <v-row>
    <v-col cols="12">
      <h2>{{ $t('minesweeper.head') }}</h2>
    </v-col>
    <v-col cols="12">
      <v-form ref="form" v-model="formValid">
        <v-card>
          <v-card-title> {{ $t('minesweeper.head_list1') }} </v-card-title>
          <v-divider class="mx-3" />
          <v-card-actions>
            <v-row no-gutters>
              <v-col cols="12" xs="12" md="6" lg="4">
                <v-text-field class="px-1" :label="$t('minesweeper.reward_amount')" v-model="gameData.reward_amount"
                  type="number" :placeholder="$t('minesweeper.reward_amount')" :rules="rules" dense outlined
                  hide-spin-buttons />
              </v-col>
              <v-col cols="12" xs="12" md="6" lg="4">
                <v-select class="px-1" :label="$t('minesweeper.reward_type')" v-model="gameData.reward_type"
                  :rules="[v => !!v || '']" :items="typeItems" item-text="name" dense outlined />
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-title> {{ $t('minesweeper.head_list2') }} </v-card-title>
          <v-divider class="mx-3" />
          <v-card-actions>
            <v-row no-gutters>
              <v-col cols="12" xs="12" md="6" lg="4">
                <v-text-field class="px-1" :label="$t('minesweeper.width')" v-model="gameData.width" type="number"
                  :placeholder="$t('minesweeper.width')" :rules="rules" dense outlined hide-spin-buttons />
              </v-col>
              <v-col cols="12" xs="12" md="6" lg="4">
                <v-text-field class="px-1" :label="$t('minesweeper.height')" v-model="gameData.height" type="number"
                  :placeholder="$t('minesweeper.height')" :rules="rules" dense outlined hide-spin-buttons />
              </v-col>
              <v-col cols="12" xs="12" md="6" lg="4">
                <v-text-field class="px-1" :label="$t('minesweeper.bomb')" v-model="gameData.bomb" type="number"
                  :placeholder="$t('minesweeper.bomb')" :rules="rules" dense outlined hide-spin-buttons />
              </v-col>
              <v-text-field class="px-1" :label="$t('minesweeper.percent')" v-model="gameData.percent" type="number"
                :placeholder="$t('minesweeper.percent')" :rules="rules" dense outlined hide-spin-buttons />
              <v-col cols="12" xs="12" md="6" lg="4"></v-col>
            </v-row>
          </v-card-actions>
          <v-card-title> {{ $t('minesweeper.head_list3') }} </v-card-title>
          <v-divider class="px-3" />
          <v-card-actions>
            <v-col cols="12" xs="12" md="6" lg="4" class="px-0">
              <v-col cols="12" class="px-0">
                <v-row no-gutters>
                  <v-col cols="5" xs="5" md="5" lg="5">
                    <v-row no-gutters>
                      <v-checkbox class="mt-1" v-model="isNotLimitPlay" />
                      <span class="mt-2">{{ $t('minesweeper.no_limit_play') }}</span>
                    </v-row>
                  </v-col>
                  <v-col cols="7" xs="7" md="7" lg="7">
                    <v-text-field class="px-1" :label="$t('minesweeper.limit_play')" v-model="gameData.limit_play"
                      type="number" :placeholder="$t('minesweeper.limit_play')" :rules="isNotLimitPlay ? [] : rules"
                      :disabled="isNotLimitPlay" dense outlined hide-spin-buttons />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="px-0">
                <v-row no-gutters>
                  <v-col cols="5" xs="5" md="5" lg="5">
                    <v-row no-gutters>
                      <v-checkbox class="mt-1" v-model="isNotLimitGameTime" />
                      <span class="mt-2">{{ $t('minesweeper.no_game_time') }}</span>
                    </v-row>
                  </v-col>
                  <v-col cols="7" xs="7" md="7" lg="7">
                    <v-text-field class="px-1" :label="$t('minesweeper.game_time')" v-model="gameData.game_time"
                      type="number" :placeholder="$t('minesweeper.game_time')" :rules="isNotLimitGameTime ? [] : rules"
                      :disabled="isNotLimitGameTime" dense outlined hide-spin-buttons />
                  </v-col>
                </v-row>
              </v-col>
            </v-col>
          </v-card-actions>
          <v-card-actions>
            <v-spacer />
            <v-btn @click="saveData" :loading="loading" color="success" class="white--text px-5">
              {{ $t('save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import DatePickerInput from '@/components/input/DatePickerInput.vue'
import SelectInput from '@/components/input/SelectInput.vue'

export default {
  components: {
    DatePickerInput,
    SelectInput,
  },

  data() {
    return {
      formValid: true,
      loading: false,
      gameData: {
        width: null,
        height: null,
        bomb: null,
        reward_type: null,
        reward_amount: null,
        limit_play: null,
        limit_win: null,
        percent: null,
        game_time: null,
      },
      isNotLimitPlay: false,
      isNotLimitGameTime: false,
      rules: [
        value => (value !== '' && value !== null && value !== undefined) || this.$t('alert_list.list1'),
        value => /^[0-9]+(\.[0-9]{0,2})?$/.test(value) || this.$t('alert_list.list2'),
      ],
      typeItems: [
        {
          name: 'Point',
          value: 'point',
        },
        {
          name: 'Coin',
          value: 'coin',
        },
        {
          name: 'Money',
          value: 'money',
        },
      ],
    }
  },
  async created() {
    this.addLogPage()
    this.getData()
  },
  watch: {

  },
  methods: {
    async addLogPage() {
      try {
        let data
        const userSystem = store.getters.getuserInfo
        await axios.get('https://api.ipify.org?format=json').then(res =>
          (data = {
            ip: res.data.ip,
            name: 'MineSweeper',
            url: window.location.href,
            detail: 'ตั้งค่า MineSweeper',
            admin: userSystem.name ? userSystem.name : '' ? userSystem.name : '',
          }),
        )
        await this.$store.dispatch('addLogPage', data)
      } catch (e) {
        // if (!e.message.includes('Unexpected token') || !e?.includes('Unexpected token') || !e.message.includes('Unexpected identifier')) {
        //   this.$swal.fire({
        //     icon: 'error',
        //     title: e.message,
        //   })
        // }
      }
    },
    async getData() {
      try {
        let res = await this.$store.dispatch('getMineSweeperData', 'name=minesweeper')
        let resData = res
        if (resData && resData.data) {
          this.gameData = resData.data
          this.isNotLimitPlay = this.gameData.limit_play ? false : true
          this.isNotLimitGameTime = this.gameData.game_time ? false : true
        }
      } catch (e) { }
    },
    async saveData() {
      this.loading = true
      let validate = [];
      if (this.$refs.form.validate()) {
        for (let key in this.gameData) {
          if (this.gameData.hasOwnProperty(key)) {
            let value = this.gameData[key];

            if ((key === 'limit_play' && this.isNotLimitPlay) || (key === 'game_time' && this.isNotLimitGameTime)) {
              value = 0;
              this.gameData[key] = value;
            }

            if (
                (key === 'limit_play' && !this.isNotLimitPlay && value === 0) ||
                (key === 'game_time' && !this.isNotLimitGameTime && value === 0)
              ) {
              this.$swal.fire(this.$t('alert_list.list2'), '', 'error')
            }

            if (
              (this.gameData.bomb && this.gameData.width && this.gameData.height) &&
              (this.gameData.bomb >= (this.gameData.width * this.gameData.height))
              ) {
              this.$swal.fire(this.$t('alert_list.list14'), '', 'error')
            }

            if (!isNaN(parseInt(value))) {
              this.gameData[key] = parseInt(value);
            }
          }
        }

        if(validate){
          try {
            let res = await this.$store.dispatch('saveMineSweeperData', this.gameData)
            this.$swal.fire(this.$t("update_success"), '', 'success')
          } catch (e) { }
        }
      }
      this.loading = false
    },
    handleInput(fieldName, event) {
      let newValue = event;

      // Remove non-digit characters except for dot (.)
      newValue = newValue.replace(/[^\d.]/g, '');

      // Limit to two digits after the dot
      // console.log(newValue)
      const dotIndex = newValue.indexOf('.');
      let moreThanTwoDigits = false
      if (dotIndex !== -1) {
        const digitsAfterDot = newValue.length - dotIndex - 1;
        // console.log(digitsAfterDot)
        if (digitsAfterDot > 2) {
          moreThanTwoDigits = true;
          newValue = newValue.slice(0, dotIndex + 3);
        }
      }

      // Update the value in gameData object
      // console.log(moreThanTwoDigits)
      if (!moreThanTwoDigits) {
        this.gameData[fieldName] = newValue;
      }
    },
  },
}
</script>
